import { csmsUserModelNormalizer } from '@energy-stacks/csms/feature-users-data';
import { useLogin } from '@energy-stacks/user-access';

export const CsmsUserLogin = () => {
  useLogin(csmsUserModelNormalizer);
  return null;
};
